<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="icon header">
      <i class="info icon"></i>
      {{ $t("message info") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/inspection.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <pre>{{ setup }}</pre>
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
// import moment from "moment";

export default {
  name: "ProviderModalIndex",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      uuid: "",
      setup: {
        name: "",
        addressee: "",
        send_date: "",
        provider_id: "",
        message_args: [],
      },
    };
  },
  methods: {
    show_modal(uuid) {
      let vm = this;

      /**
       * get template
       */
      if (uuid) {
        local_api(vm, "post", "/outbox/message/do-get", {
          u: uuid,
        })
          .then((msg) => {
            delete msg.out_template;
            vm.setup = msg;
            // let args = msg.setup.message_args;
            // vm.setup.message_args = args;
            // vm.setup.template_id = msg.out_template.template_id;

            // vm.setup.name = msg.name;
            // vm.setup.addressee = msg.setup.addressee;
            // if (msg.programmed_send_date) {
            //   vm.setup.send_date = msg.programmed_send_date;
            //   window
            //     .jQuery(vm.$refs.send_date)
            //     .calendar("set date", msg.programmed_send_date);
            // }
            // vm.uuid = msg.uuid;
            // vm.provider_id: "",
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          allowMultiple: true,
          onVisible() {},
          onHide() {},
        })
        .modal("show");
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
